import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/markets/company_settings/new/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/markets/company_settings/new';

const Home: NextPage = () => (
  <>
    <NskHead title="修繕おまかせサービス 利用開始" />
    <Component />
  </>
);

export default Home;
